import Aside from '@UI/aside/Aside';
import AsideAccessRights from '@UI/aside/asideAccessRights/AsideAccessRights';
import AsideAgeRange from '@UI/aside/asideAgeRange/AsideAgeRange';
import AsideAttachedContent from '@UI/aside/asideAttachedContent/AsideAttachedContent';
import AsideAttachmentGroupType from '@UI/aside/asideAttachmentGroupType/AsideAttachmentGroupType';
import AsideCheckbox from '@UI/aside/asideCheckbox/AsideCheckbox';
import AsideColor from '@UI/aside/asideColor/AsideColor';
import AsideConcordanties from '@UI/aside/asideConcordanties/AsideConcordanties';
import AsideCoverage from '@UI/aside/asideCoverage/AsideCoverage';
import AsideCurriculumSelector from '@UI/aside/asideCurriculumSelector/AsideCurriculumSelector';
import AsideCurriculumTheme from '@UI/aside/asideCurriculumTheme/asideCurriculumTheme';
import AsideCurriculumType from '@UI/aside/asideCurriculumType/AsideCurriculumType';
import AsideDatePicker from '@UI/aside/asideDatePicker/AsideDatePicker';
import AsideDateToSendPicker from '@UI/aside/asideDatePicker/AsideDateToSendPicker';
import AsideIssuedDatePicker from '@UI/aside/asideDatePicker/AsideIssuedDatePicker';
import AsideDescription from '@UI/aside/asideDescription/AsideDescription';
import AsideDevelopmentPhase from '@UI/aside/asideDevelopmentPhase/AsideDevelopmentPhase';
import AsideFile from '@UI/aside/asideFileSelector/AsideFile';
import AsideFoundationalSuggestions from '@UI/aside/asideFoundationalSuggestions/AsideFoundationalSuggestions';
import AsideFreeTextAuthor from '@UI/aside/asideFreeTextAuthor/AsideFreeTextAuthor';
import AsideGoalRelations from '@UI/aside/asideGoalRelations/AsideGoalRelations';
import AsideGoalsByZillIllustration from '@UI/aside/asideGoalsByZillIllustration/asideGoalsByZillIllustration';
import AsideImage from '@UI/aside/asideImage/AsideImage';
import AsideLeerlijnReference from '@UI/aside/asideLeerlijnReference/AsideLeerlijnReference';
import AsideLinks from '@UI/aside/asideLinks/AsideLinks';
import AsideMenuItemReference from '@UI/aside/asideMenuItemReference/AsideMenuItemReference';
import AsideNamedSet from '@UI/aside/asideNamedSet/AsideNamedSet';
import AsideNewsletterSender from '@UI/aside/asideNewsletterSender/AsideNewsletterSender';
import AsideNodeVersions from '@UI/aside/asideNodeVersions/AsideNodeVersions';
import AsidePersonPicker from '@UI/aside/asidePersonPicker/AsidePersonPicker';
import AsidePracticalExampleReferences from '@UI/aside/asidePracticalExampleReferences/asidePracticalExampleReferences';
import AsidePreviousVersion from '@UI/aside/asidePreviousVersion/AsidePreviousVersion';
import AsidePreviousVersionItems from '@UI/aside/asidePreviousVersionItems/AsidePreviousVersionItems';
import AsideReferenceFrameReferences from '@UI/aside/asideReferenceFrameReferences/AsideReferenceFrameReferences';
import AsideReferenceGroup from '@UI/aside/asideReferenceGroup/AsideReferenceGroup';
import AsideTitle from '@UI/aside/asideRichTextInput/AsideTitle';
import AsideSecondaryEducationType from '@UI/aside/asideSecondaryEducationType/AsideSecondaryEducationType';
import AsideSimpleDropDown from '@UI/aside/asideSimpleDropDown/AsideSimpleDropDown';
import AsideIdentifier from '@UI/aside/asideSimpleInput/AsideIdentifier';
import AsideValidityPeriod from '@UI/aside/asideSimpleInput/AsideValidityPeriod';
import AsideVersion from '@UI/aside/asideSimpleInput/AsideVersion';
import AsideSources from '@UI/aside/asideSources/AsideSources';
import AsideStaticHtml from '@UI/aside/asideStaticHtml/AsideStaticHtml';
import AsideStudyProgrammes from '@UI/aside/asideStudyProgrammes/AsideStudyProgrammes';
import AsideSubjects from '@UI/aside/asideSubjects/AsideSubjects';
import AsideTeaserImportance from '@UI/aside/asideTeaserImportance/AsideTeaserImportance';
import AsideTeaserLinkedContent from '@UI/aside/asideTeaserLinkedContent/AsideTeaserLinkedContent';
import AsideThemes from '@UI/aside/asideThemes/AsideThemes';
import AsideVideo from '@UI/aside/asideVideo/AsideVideo';
import AsideWebDatePicker from '@UI/aside/asideWebDatePicker/AsideWebDatePicker';
import AsideReferenceFramePicker from '@UI/aside/asideWebFacet/AsideReferenceFramePicker';
import AsideWebFacetPlaceHolder from '@UI/aside/asideWebFacet/AsideWebFacetPlaceHolder';
import AsideZillGoals from '@UI/aside/asideWebFacet/AsideZillGoals';
import AsideWebFacets from '@UI/aside/asideWebFacets/AsideWebFacets';
import AsideWebOldUrls from '@UI/aside/asideWebOldUrls/AsideWebOldUrls';
import AsideWebSimpleCheckbox from '@UI/aside/asideWebSimpleCheckbox/AsideWebSimpleCheckbox';
import AsideWebSimpleInput from '@UI/aside/asideWebSimpleInput/AsideWebSimpleInput';
import AsideWebType from '@UI/aside/asideWebType/AsideWebType';
import AsideZillIllustrations from '@UI/aside/asideZillIllustrations/asideZillIllustrations';
import BuildingBlocks from '@UI/buildingBlocks/BuildingBlocks';
import AsideEditor from '@UI/editor/AsideEditor';
import EncodedText from '@UI/encodedText/EncodedText';
import ContentRow from '@UI/mainScreen/contentRow/ContentRow';
import Document from '@UI/mainScreen/document/Document';
import SaveButton from '@UI/saveButton/SaveButton';
import { reactToAngularComponent } from '@kathondvla/react-shared-components/src/helpers/angularReactHelper';
import StoreProvider from '@store/StoreProvider';
import app from '../app/app';
import DocumentListTable from '@UI/mainScreen/documentListTable/DocumentListTable';

app.component(
  'reactAsideGoalRelations',
  reactToAngularComponent(AsideGoalRelations, StoreProvider),
);
app.component('reactEncodedText', reactToAngularComponent(EncodedText, StoreProvider));

app.component('reactDocumentListTable', reactToAngularComponent(DocumentListTable, StoreProvider));

app.component('reactContentRow', reactToAngularComponent(ContentRow, StoreProvider));
app.component('reactDocument', reactToAngularComponent(Document, StoreProvider));
app.component('reactBuildingBlocks', reactToAngularComponent(BuildingBlocks, StoreProvider));
app.component('reactSaveButton', reactToAngularComponent(SaveButton, StoreProvider));

app.component('reactAsideEditor', reactToAngularComponent(AsideEditor, StoreProvider));

const asideReactComponents = [
  AsideWebSimpleInput,
  AsideWebSimpleCheckbox,
  AsideWebType,
  AsideWebFacets,
  AsideWebOldUrls,
  AsideWebDatePicker,
  AsideAttachmentGroupType,
  AsideNodeVersions,
  AsideFreeTextAuthor,
  AsideNewsletterSender,
  AsideSources,
  AsideSimpleDropDown,
  AsideValidityPeriod,
  AsideVersion,
  AsideImage,
  AsideVideo,
  AsideFile,
  AsideIdentifier,
  AsideTitle,
  AsideSubjects,
  AsideStaticHtml,
  AsideDescription,
  AsidePreviousVersion,
  AsidePreviousVersionItems,
  AsideSecondaryEducationType,
  AsideCheckbox,
  AsidePersonPicker,
  AsideColor,
  AsideTeaserImportance,
  AsideReferenceFrameReferences,
  AsideDatePicker,
  AsideDateToSendPicker,
  AsideIssuedDatePicker,
  AsideLinks,
  AsideCurriculumTheme,
  AsideStudyProgrammes,
  AsideNamedSet,
  AsideCoverage,
  AsideCurriculumSelector,
  AsideTeaserLinkedContent,
  AsideAttachedContent,
  AsideConcordanties,
  AsideDevelopmentPhase,
  AsideWebFacetPlaceHolder,
  AsideAgeRange,
  AsideReferenceFramePicker,
  AsideZillGoals,
  AsideThemes,
  AsideAccessRights,
  AsideCurriculumType,
  AsidePracticalExampleReferences,
  AsideZillIllustrations,
  AsideGoalsByZillIllustration,
  AsideMenuItemReference,
  AsideFoundationalSuggestions,
  AsideLeerlijnReference,
  AsideReferenceGroup,
  Aside,
];

asideReactComponents.forEach((component) => {
  if (!component.displayName) {
    console.error('Component does not have a displayName', component);
  } else {
    app.component(
      `react${component.displayName}`,
      reactToAngularComponent(component, StoreProvider),
    );
  }
});
